import { isDefined } from "@/common/utils/Utils";
import firebase from "firebase/app";
import { httpService } from "@/common/services/HttpService";

class AuthService {
  private _state: AuthState | null = null;

  clearState(): void {
    this._state = null;
    httpService.removeAuthorizationHeader();
  }

  setState(state: AuthState): void {
    this._state = state;
    httpService.setAuthorizationHeader(this._state.token);
  }

  getState(): AuthState | null {
    return this._state;
  }

  isLoggedIn(): boolean {
    return (
      isDefined(this._state) &&
      isDefined(this._state?.claims) &&
      isDefined(this._state?.expirationTime) &&
      isDefined(this._state?.refreshToken) &&
      isDefined(this._state?.token) &&
      isDefined(this._state?.userID)
    );
  }

  async logout(): Promise<void> {
    await firebase.auth().signOut();
    this.clearState();
  }
}

export const authService = new AuthService();

export interface AuthState {
  claims: object;
  expirationTime: string;
  refreshToken: string;
  token: string;
  userID: string;
}
